import React from 'react';
import { Card, CardBody, CardFooter, CardHeader } from '@progress/kendo-react-layout';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { UserApi } from '../../../../../../redux/api/UserApi';
import * as svg from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import EmailForm from './EmailForm';
import ConfirmClose from './ConfirmClose';
import AINotes from '../../AINotes';
import AddKBButton from '../KB/AddKBButton';

interface EmailActionProps {
    onclosed?: () => void
    onsubmitted?: () => void
    onpopout?: () => void
}

const EmailAction: React.FC<EmailActionProps> = (props) => {
    const { ticketId } = useParams();
    const [confirmCloseVisible, setConfirmCloseVisible] = React.useState(false);
    const { data: userProfile } = UserApi.useGetUserProfileQuery();

    const closeClicked = () => {
        setConfirmCloseVisible(true);
    };

    const closeConfirmed = () => {
        setConfirmCloseVisible(false);

        if (props.onclosed) {
            props.onclosed();
        }
    }

    return (
        <Card className="no-pop">
            <CardHeader className='action-header' style={{ color: '#fff', background: userProfile?.Nav_Hex_Color }}>
                <div className='d-flex align-items-center flex-row flex-grow justify-content-between'>
                    <div>
                        <SvgIcon size='large' icon={svg.envelopIcon} className='mr-2' ></SvgIcon>Send Email</div>
                    {/*Link goes on the far right */}
                    <div>
                        <Link onClick={() => props.onpopout && props.onpopout()} className='align-items-right' to={`./email`} title='Pop out' style={{ color: '#fff' }}>
                            <Button fillMode='flat' size='medium' svgIcon={svg.windowRestoreIcon} className='off'></Button>
                        </Link>
                        <Button fillMode='flat' size='medium' svgIcon={svg.xIcon} title='close' onClick={closeClicked}></Button>
                    </div>
                </div>
            </CardHeader>
            <CardBody>
                <ConfirmClose ticketId={parseInt(ticketId)} visible={confirmCloseVisible} onClose={() => setConfirmCloseVisible(false)} onDiscard={closeConfirmed} />
                <EmailForm onsubmitted={props.onsubmitted} />
            </CardBody>
            <CardFooter className='email-action-footer'>
                <div className='mr-2'><AddKBButton from='email' /></div>
                {!userProfile?.Features.External_Interface && <AINotes controlMode='email' />}
                <Button form='email-action-form' svgIcon={svg.paperPlaneIcon} type='submit' className='p-2' style={{ width: '100px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                    Send
                </Button>
            </CardFooter>
        </Card>
    );
};

export default EmailAction;